/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PELEnvLinedirectives.templates.Remove Covered Location',
        defaultMessage: 'Remove Covered Location',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PELEnvLinedirectives.templates.riskanalysisRemovalMsg',
        defaultMessage: 'Are you sure you want to remove this Covered Location from the list?',
    },
    coveredLocation: {
        id: 'quoteandbind.PELEnvLinedirectives.templates.coveredLocation',
        defaultMessage: 'Covered Location'
    }
});